var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkedin = function SvgIconLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#636874",
    d: "M21.143 0H2.858A2.86 2.86 0 0 0 0 2.857v18.286A2.86 2.86 0 0 0 2.858 24h18.285A2.86 2.86 0 0 0 24 21.143V2.857A2.86 2.86 0 0 0 21.144 0M7.43 9.143V20H4V9.143zM4 5.983c0-.8.686-1.412 1.715-1.412s1.674.612 1.714 1.412c0 .8-.64 1.446-1.714 1.446C4.686 7.429 4 6.783 4 5.983M20 20h-3.428v-5.714c0-1.143-.572-2.286-2-2.309h-.046c-1.383 0-1.954 1.177-1.954 2.309V20H9.143V9.143h3.429v1.463s1.103-1.463 3.32-1.463c2.268 0 4.108 1.56 4.108 4.72z"
  })));
};
export default SvgIconLinkedin;